import baseLogger, { CONTEXTS } from 'widget/logger';
import createTaggedUrl from 'api/createTaggedUrl';
import HttpError from 'widget/Errors/HttpError';
import Logger from 'modules/Logger/Logger';
import { AxiosResponse } from 'axios';
import { TransportInterface } from 'widget/utils/transport/types';
import type { Playlist } from 'state/Playlist/types';

/*
 * Fetch playlist radio data given a playlist id
 */

const tracksBatchRequests = (
  ampUrl: string,
  trackIds: Array<number>,
  transport: TransportInterface,
) => {
  const batchRequests: Array<Promise<AxiosResponse>> = [];

  while (trackIds.length) {
    const [url, requestName] = createTaggedUrl`${{
      ampUrl,
    }}/api/v3/catalog/tracks/${{
      tracks: String(trackIds.splice(0, 50)),
    }}`;

    batchRequests.push(transport.get(url, { params: { requestName } }));
  }

  return batchRequests;
};

export async function fetchPlaylistTracks({
  ampUrl,
  logger = baseLogger,
  trackIds,
  transport,
}: {
  ampUrl: string;
  logger?: Logger;
  trackIds: Array<number>;
  transport: TransportInterface;
}) {
  if (!trackIds) {
    const errObj = new HttpError(
      400,
      'Failed to fetch playlist radio info, playlist radio id missing.',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }

  const response = await Promise.all(
    tracksBatchRequests(ampUrl, trackIds, transport),
  );

  const tracks = response
    .filter(res => {
      const { data } = res as { data?: Playlist };

      return data && data?.tracks.length > 1;
    })
    .map(res => {
      const { data } = res as { data: Playlist };

      return data.tracks;
    })
    .flat();

  if (tracks?.length < 1) {
    const errObj = new HttpError(
      400,
      'Failed to fetch playlist radio info, no results.',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }

  return tracks;
}
